import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import Filter from 'views/financial/depositRequests/filter'; // Importing Filter component
import Table from 'views/financial/depositRequests/table'; // Importing Table component
import Record from 'views/financial/depositRequests/record'; // Importing Record component
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the deposit requests view.
 * @extends JetView
 */
export default class depositRequestsView extends JetView {
    /**
     * Configures the UI components of the deposit requests view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Current theme configuration

        // Right panel configuration
        const right = {
            type: 'wide',
            rows: [Record], // Contains the Record component
        };

        // Alternative right panel configuration for smaller screens
        const right2 = {
            height: 1,
            id: 'right2',
            width: screen.width - 54,
            type: 'wide',
            rows: [Record], // Contains the Record component
        };

        // Toolbar configuration
        const toolbar = {
            view: 'toolbar',
            id: 'toolbar',
            css: 'highlighted_header header6', // CSS classes for styling
            paddingX: 5,
            paddingY: 5,
            height: 40,
            cols: [
                {
                    view: 'select', // Dropdown for selecting page size
                    id: 'select',
                    options: ['10', '20', '50', '100', '1000', '10000'], // Page size options
                    width: 70,
                    on: {
                        onChange: function () {
                            // Event handler for page size change
                            $$('datatable').getPager().config.size = this.getValue() * 1; // Update pager size
                            $$('datatable').refresh(); // Refresh the datatable
                        },
                    },
                },
                {
                    view: 'pager', // Pager component for navigation
                    id: 'pagerA',
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}',
                    autosize: false,
                    animate: {
                        subtype: 'out',
                    },
                    height: 35,
                    size: devConfig.getDefaultDataFetch(), // Default fetch size from config
                },
                {
                    view: 'richselect', // Dropdown for export options
                    name: 'Export',
                    id: 'Export',
                    width: 120,
                    placeholder: _('Exportar'), // Placeholder text
                    options: [
                        { id: '1', value: 'Excel' }, // Excel export option
                        { id: '2', value: 'PDF' }, // PDF export option
                    ],
                    on: {
                        onChange: function (value) {
                            // Event handler for export option change
                            var size = $$('datatable').getPager().config.size; // Current page size
                            var page = $$('datatable').getPage(); // Current page number
                            var first = size * page; // First item index
                            var last = first + size - 1; // Last item index

                            if (value == 1) {
                                // If Excel is selected
                                var table = $$('datatable'); // Reference to the datatable
                                for (var j = 0; j < table.config.columns.length; j++) {
                                    if (table.config.columns[j].exportType) {
                                        delete table.config.columns[j].format; // Remove format for export
                                    }
                                }
                                webix.toExcel(table, {
                                    // Export to Excel
                                    filename:
                                        'Virtualsoft - ' +
                                        new Date()
                                            .toLocaleString('en-GB', {
                                                hour12: true,
                                            })
                                            .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                            .replace(/[\/:]/g, '_')
                                            .toUpperCase() +
                                        ' - ' +
                                        ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                        'Solicitudes de Depósitos',
                                    ignore: {
                                        detailTittle: true,
                                        ActionTittle: true,
                                    },
                                    footer: false,
                                });
                            } else {
                                if (value == 2) {
                                    // If PDF is selected
                                    webix.toPDF($$('datatable'), {
                                        // Export to PDF
                                        filename:
                                            'Virtualsoft - ' +
                                            new Date()
                                                .toLocaleString('en-GB', {
                                                    hour12: true,
                                                })
                                                .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                                .replace(/[\/:]/g, '_')
                                                .toUpperCase() +
                                            ' - ' +
                                            ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                            'Solicitudes de Depósitos',
                                        autowidth: true,
                                        ignore: {
                                            detailTittle: true,
                                            ActionTittle: true,
                                        },
                                        footer: false,
                                    });
                                }
                            }
                            $$('Export').setValue(''); // Reset export selection
                        },
                    },
                },
            ],
        };

        // Left panel configuration
        const left = {
            css: 'int-left',
            rows: [
                {
                    view: 'toolbar', // Toolbar for the left panel
                    css: theme,
                    elements: [
                        { view: 'label', label: _('Solicitudes de Depósitos') }, // Title label
                        {
                            type: 'wide',
                            css: 'close-bottom',
                            id: 'button-search', // Search button
                            cols: [
                                {
                                    view: 'icon',
                                    icon: 'wxi-search', // Search icon
                                    bottom: 20,
                                    right: 35,
                                    width: 30,
                                    height: 30,
                                    click: () => {
                                        $$('filterPopup').show(); // Show filter popup on click
                                    },
                                },
                            ],
                        },
                    ],
                },
                Filter, // Filter component
                Table, // Table component
                toolbar, // Toolbar component
            ],
        };

        // Advanced details accordion configuration
        const avanc = {
            view: 'accordion',
            multi: true,
            collapsed: true,
            cols: [
                { id: 'dColl', header: _('Detalles Avanzados'), body: right }, // Accordion item
            ],
        };

        // Alternative advanced details accordion configuration
        const avancResp = {
            view: 'accordion',
            multi: true,
            collapsed: true,
            rows: [
                {
                    id: 'dColl',
                    header: _('Detalles Avanzados'),
                    body: right, // Accordion body
                    minWidth: 200,
                    on: {
                        onItemClick: function () {
                            // Event handler for item click
                            var height;
                            $(function () {
                                height =
                                    $('.scrolling > .webix_scroll_cont').height() -
                                    $('.webix_view.webix_form.scrolling.webix_layout_clean').height(); // Calculate height for scrolling
                                if (!$$('dColl').config.collapsed) {
                                    $('.scrolling > .webix_scroll_cont').css({
                                        transform: 'translate3d(0px, -' + height + 'px, 0px)', // Adjust scroll position
                                    });
                                } else {
                                    height =
                                        $('.scrolling > .webix_scroll_cont').height() -
                                        $('.webix_view.webix_form.scrolling.webix_layout_clean').height();
                                    $('.scrolling > .webix_scroll_cont').css({
                                        transform: 'translate3d(0px, -' + height + 'px, 0px)', // Adjust scroll position
                                    });
                                }
                            });
                        },
                    },
                },
            ],
        };

        webix.ui.fullScreen(); // Set the UI to full screen mode

        // Main layout configuration
        return {
            id: 'a5',
            type: 'clean',
            view: 'form',
            scroll: 'y', // Enable vertical scrolling
            css: 'scrolling',
            rows: [
                {
                    responsive: 'a5',
                    type: 'wide',
                    cols: [
                        left, // Left panel
                        screen.width < 500 || screen.height < 500
                            ? right2 // Use right2 for small screens
                            : avanc, // Use avanc for larger screens
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event handlers.
     * @param {Object} grid - The grid component.
     */
    init(grid) {
        webix.ready(function () {
            if (screen.width < 500 || screen.height < 500) {
                var childs = $$('toolbar').getChildViews(); // Get child views of the toolbar
                $$('toolbar').removeView(childs[2]); // Remove the export dropdown for small screens
                $$('pagerA').define('group', 1); // Define pager group for small screens
            }
            if (screen.width > 500 && screen.height > 500) {
                $$('button-search').hide(); // Hide search button for larger screens
            }
        });
    }
}

// FILE DOCUMENTED
